import { render, staticRenderFns } from "./ThirdPartyCard.vue?vue&type=template&id=b0417002&scoped=true"
import script from "./ThirdPartyCard.vue?vue&type=script&lang=js"
export * from "./ThirdPartyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0417002",
  null
  
)

export default component.exports